module.exports = __webpack_public_path__ + "media/images/gifts/art/sug_arte_2-9612723fd8414c2eb9e9d95701290efe.jpg";